module.exports = __webpack_public_path__ + "img/icon-crp-big.13a60fe8.png";